import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { UpdateIncidentStatus } from '../mutations/updateIncidentStatus.mutation';
import type { UpdateIncidentStatusMutation, UpdateIncidentStatusMutationVariables } from '../types';

export const useUpdateIncidentStatusMutation = (
  options?: MutationOptions<UpdateIncidentStatusMutation, UpdateIncidentStatusMutationVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(UpdateIncidentStatus), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('incident'),
      });
    },
  });
};
